import { Button, Checkbox, Col, Form, Input, InputNumber, Row } from 'antd';
import { useEffect, useState } from 'react'
import { GetById_ObjectType_Api, Update_ObjectType_Api } from '../../API/objectTypeApi';
import { SaveOutlined, RollbackOutlined, CheckOutlined } from '@ant-design/icons';
// =================================================================
export const EditObjectTypeComponent = ({ id, setLoading, showMessage, rowUpdated, cancelEdit }) => {
    // =================================================================
    const [objectType, setObjectType] = useState();
    const [form] = Form.useForm()
    // =================================================================
    useEffect(() => {
        loadData();
    }, [id]);
    // =================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetById_ObjectType_Api(id);
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setObjectType(data.messageData.data);
                form.setFieldsValue(data.messageData.data);
            }
            else 
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const onSubmit = async (values) => {
            setLoading(true);
        try {
            values.id = id;
            let data = await Update_ObjectType_Api(values);
            setLoading(false);

            if (data.messageStatus == "Successful") {
                showMessage(data.message, "Successful")
                rowUpdated();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    };
    // =================================================================
    const onFinishFailed = (errorInfo) => {
        showMessage(errorInfo, "error")
    };
    // =================================================================
    return (
        <>
            {objectType ? (
                <>
                    <div className='sectionTitle'>
                        <h2 >
                            ویرایش {objectType.title}
                        </h2>
                    </div>
                    <div className='container'>
                        <Form
                            form={form}
                            name="basic"
                            labelCol={{ span: 3 }}
                            wrapperCol={{ span: 21 }}
                            onFinish={onSubmit}
                            onFinishFailed={onFinishFailed}
                        >
                            <Form.Item
                                name="title"
                                label="عنوان"
                                rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                            >
                                <Input placeholder='عنوان' />
                            </Form.Item>

                            <Form.Item
                                name="comment"
                                label="شرح"
                                rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                            >
                                <Input placeholder='شرح' />
                            </Form.Item>

                            <Form.Item
                                name="orderIndex"
                                label="ترتیب"
                            >
                                <InputNumber />
                            </Form.Item>

                            <Form.Item
                                name="isActive"
                                valuePropName='checked'
                                label="فعال"
                            >
                                <Checkbox checked={objectType.isActive}> </Checkbox>
                            </Form.Item>
                        </Form>
                    </div>

                    <Row className='sectionFooter'>
                        <Col xs={0} sm={0} md={8} lg={16} xl={16} >
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                            <Button
                                style={{ width: '98%' }}
                                className='btn-primary'
                                htmlType="submit"
                                onClick={() => form.submit()}>
                                <CheckOutlined />
                                ذخیره
                            </Button>
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                            <Button
                                className='btn-secondary'
                                style={{ width: '100%' }}
                                onClick={() => cancelEdit()}>
                                <RollbackOutlined />
                                لغو </Button>
                        </Col>
                    </Row>

                </>


            )
                : (<></>)}
        </>
    )
}
